// シグナル3段階のユーザー向け表示ラベル。
// 内部キー（ok/warn/danger）は配色・ロジック・JSONスキーマで使い続け、
// 表示テキストだけをここに集約する。増減率の監視は増加・減少どちらの急変も拾うため、
// 「悪い事態」を含意する語（危険/DANGER）を避け、変化の大きさを中立に表す語にしている。

export const SIGNAL_LABEL = {
  ok: "平常",
  warn: "変動",
  danger: "急変",
};

export const SIGNAL_LABEL_EN = {
  ok: "STEADY",
  warn: "SHIFT",
  danger: "SWING",
};
